import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Permission } from '../models/user.model';
import { PermissionService } from '../services/permission.service';

/** ROL-01/04: gates a route behind a permission — server still re-checks on every call, this
 *  just avoids a signed-in-but-unauthorized user landing on a page that will 403 every request.
 *  With several permissions, any one of them is enough. */
export function permissionGuard(...required: Permission[]): CanActivateFn {
  return () => {
    const permissions = inject(PermissionService);
    const router = inject(Router);
    return required.some((p) => permissions.can(p)) ? true : router.parseUrl('/dashboard');
  };
}
